import { FormikProps, FormikValues } from 'formik';

export const isInitialValid = (props: FormikValues) => {
  if (!props.validationSchema) {
    return true;
  }

  return props.validationSchema.isValidSync(props.initialValues);
};

export const isFieldTouched = (form: FormikProps<any>, field: string) =>
  form.errors[field] !== undefined && form.touched[field] !== undefined;

export const isPostcodeFieldTouched = (form: FormikProps<any>, field: string) => {
  const error = form.errors['hiddenPostcode'] !== undefined || form.errors[field] !== undefined;
  return error && form.touched[field];
};

export const getGraphQLErrorMessage = (graphQLErrors: any, input: any) => {
  if (graphQLErrors && graphQLErrors.length > 0) {
    const firstError = graphQLErrors[0];
    if (firstError && firstError.extensions) {
      const { extensions } = firstError;
      if (
        extensions.code === 'USER_INPUT_ERROR' &&
        extensions.invalidField === 'postcode' &&
        extensions.invalidReason === 'STATE_MISMATCH'
      ) {
        const postcode = input.address.postcode;
        const state = input.address.state;
        return `Oops, postcode ${postcode} does not exist in ${state}. Please try again.`;
      }
    }
  }
  return undefined;
};

export const setInitialTouched = (initialValues: FormikValues) =>
  Object.entries(initialValues).reduce(
    (acc: { [key: string]: boolean }, el: [string, string | boolean | undefined | {}]) => {
      const [key] = el;
      if (initialValues[key] !== '') {
        acc[key] = true;
      }
      return acc;
    },
    {}
  );
